import React from 'react';

const RATIOS = [
  { value: '9:16', label: '9:16 Vertical', desc: 'TikTok, Reels, Shorts' },
  { value: '1:1', label: '1:1 Square', desc: 'Instagram, Facebook' },
  { value: '16:9', label: '16:9 Wide', desc: 'YouTube, Twitter' },
  { value: '4:5', label: '4:5 Portrait', desc: 'Instagram Feed' },
];

interface AspectDropdownProps {
  currentRatio: string;
  onSelect: (ratio: string) => void;
  onClose: () => void;
}

const AspectDropdown: React.FC<AspectDropdownProps> = ({ currentRatio, onSelect, onClose }) => {
  return (
    <div className="aspect-dropdown dropdown-menu">
      <div className="dropdown-header">Aspect Ratio</div>
      {RATIOS.map(r => (
        <button
          key={r.value}
          className={`dropdown-item ${currentRatio === r.value ? 'dropdown-item--active' : ''}`}
          title={`Frame the clip as ${r.label} — for ${r.desc}`}
          onClick={() => { onSelect(r.value); onClose(); }}
        >
          {currentRatio === r.value && <span className="dropdown-check">✓</span>}
          <span className="dropdown-item-label">{r.label}</span>
          <span className="dropdown-item-desc">{r.desc}</span>
        </button>
      ))}
    </div>
  );
};

export default AspectDropdown;
